export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">关于我们</h2>
          <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              每日爆料成立于2023年，是国内领先的吃瓜爆料资讯聚合平台。我们致力于为广大网友提供最新、最全、最真实的娱乐圈八卦、网红动态、社会热点等一手资讯内容。
            </p>
            <p>
              平台拥有超过50人的专业编辑团队，分布在北上广深等一线城市，7×24小时轮值运营。我们坚持真实、快速、全面的内容理念，每日更新超过200条原创及聚合爆料内容，月活跃用户已突破800万。
            </p>
            <p>
              51每日爆料网官方入口与每日爆料APP是平台两大核心产品，数据实时互通，为您提供无缝的跨端吃瓜体验。无论何时何地，打开每日爆料，最新最热的瓜都在这里等你。
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-8 mt-8 pt-6 border-t border-background-200/70">
            <div className="text-center">
              <div className="font-heading font-bold text-2xl text-primary-500">800万+</div>
              <div className="text-xs text-foreground-400 mt-1">月活跃用户</div>
            </div>
            <div className="text-center">
              <div className="font-heading font-bold text-2xl text-accent-500">200+</div>
              <div className="text-xs text-foreground-400 mt-1">日均更新</div>
            </div>
            <div className="text-center">
              <div className="font-heading font-bold text-2xl text-primary-500">50+</div>
              <div className="text-xs text-foreground-400 mt-1">专业编辑</div>
            </div>
            <div className="text-center">
              <div className="font-heading font-bold text-2xl text-accent-500">3年</div>
              <div className="text-xs text-foreground-400 mt-1">持续运营</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}